import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {fetchFormsIfNeeded, fetchForms} from '../actions';
import {fetchConversionTable} from '../actions';
import CustomerEmailFieldGroup from './CustomerEmailFieldGroup';
import FormStateGroup from './FormStateGroup';
import {Link} from 'react-router';
import moment from 'moment';
// TODO implement own picker to provide all functionality defined in form
//import Picker from '../components/Picker'
import {Table, Modal} from 'react-bootstrap';

class FormsList extends Component {
    static childContextTypes= {
        location: React.PropTypes.object
    }
    static contextTypes = {
        router: React.PropTypes.object
    }
 
    componentDidMount() {
        const {dispatch} = this.props
        dispatch(fetchFormsIfNeeded())
        dispatch(fetchConversionTable())
    }

    renderTimeStamp(timeStamps, stampState) {

        switch(stampState) {
            case 'SENT_TO_CUSTOMER':
                if (timeStamps !== undefined && timeStamps['SENT_TO_CUSTOMER']) {
                    return (<div><small>
                        {'Sent to customer: ' + moment(timeStamps['SENT_TO_CUSTOMER'], moment.ISO_8601).format("YYYY-MM-DD")}
                    </small><br/></div>);
                };
                break;
            case 'IN_PROGRESS':
                if (timeStamps !== undefined && timeStamps['IN_PROGRESS']) {
                    return (<div><small>
                        {'In Progress: ' + moment(timeStamps['IN_PROGRESS'], moment.ISO_8601).format("YYYY-MM-DD")}
                    </small><br/></div>);
                };
                break;
            case 'RETURNED_TO_VALMET':
                if (timeStamps !== undefined && timeStamps['RETURNED_TO_VALMET']) {
                    return (<div><small>
                        {'Returned to Valmet: ' + moment(timeStamps['RETURNED_TO_VALMET'], moment.ISO_8601).format("YYYY-MM-DD")}
                    </small><br/></div>);
                };
                break;
            case 'REVIEWED':
                if (timeStamps !== undefined && timeStamps['REVIEWED']) {
                    return (<div><small>
                        {'Reviewed: ' + moment(timeStamps['REVIEWED'], moment.ISO_8601).format("YYYY-MM-DD")}
                    </small><br/></div>);
                };
                break;
            case 'LASTACCESSED':
                if (timeStamps !== undefined && timeStamps['LASTACCESSED']) {
                    return (<div><small>
                        {'Accessed: ' + moment(timeStamps['LASTACCESSED'], moment.ISO_8601).format("YYYY-MM-DD")}
                    </small><br/></div>);
                };
                break;
            default:
                return (<div></div>);
        }

    }


    render() {
        const {forms, formsList, isFetching, isFetchingForms, user} = this.props;
        
        return (
            <div className="">
                {isFetchingForms && formsList.length === 0 &&
                <p>Loading...</p>
                }
                {!isFetchingForms && formsList.length === 0 &&
                <p>No surveys</p>
                }
                {forms.formsList.length > 0 &&
                <div style={{opacity: isFetching ? 0.5 : 1}}>
                    <Table striped condensed>
                        <thead>
                        <tr>
                            <th>Survey topic</th>
                            <th>Type</th>
                            <th>{user.survey_role === 'INTERNAL' ? 'Customer Contact' : 'Valmet Contact'}</th>
                            <th>Status</th>
                            <th>Timestamps</th>
                        </tr>
                        </thead>
                        <tbody>
                        {forms.formsList.map(form =>
                            <tr key={"formlist" + form.formId}>
                                <td>
                                    {user.survey_role === 'EXTERNAL' && (form.formState === 'RETURNED_TO_VALMET' || form.formState === 'REVIEWED') ? <div>{form.formName}</div> : <Link to={'/survey/' + form.formId}>{form.formName}</Link>}
                                    {form.formFilePreSignedUrl != undefined && form.formFilePreSignedUrl != "" ? <small><a href={form.formFilePreSignedUrl}>Download saved survey</a></small> : ""}
                                </td>
                                <td>{form.formType}</td>
                                <td>{user.survey_role === 'INTERNAL' ? <CustomerEmailFieldGroup formAssigneeEmail={form.formAssigneeEmail} formId={form.formId} username={user.username} /> : form.formValmetContact}</td>
                                <td>{form.formState}
                                <FormStateGroup formId={form.formId} formState={form.formState} formName= {form.formName}></FormStateGroup>
                                </td>
                                <td>
                                    {this.renderTimeStamp(form.formTimeStamps, 'SENT_TO_CUSTOMER')}
                                    {this.renderTimeStamp(form.formTimeStamps, 'IN_PROGRESS')}
                                    {this.renderTimeStamp(form.formTimeStamps, 'RETURNED_TO_VALMET')}
                                    {this.renderTimeStamp(form.formTimeStamps, 'REVIEWED')}
                                    {this.renderTimeStamp(form.formTimeStamps, 'LASTACCESSED')}
                                </td>
                            </tr>)
                        }
                        </tbody>
                    </Table>
                
                </div>
                }
               
            </div>
        )
    }
}

FormsList.propTypes = {
    forms: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired
}

function mapStateToProps(state) {

    const {forms, user} = state;
    const isFetching = forms.isFetching;
    const isFetchingForms = forms.isFetchingForms;

    return {
        forms,
        formsList: forms.formsList,
        user: user.user,
        isFetching,
        isFetchingForms,
    }
}

export default connect(mapStateToProps)(FormsList)


// WEBPACK FOOTER //
// ./src/containers/FormsList.js